import React, { useState } from 'react'
import { Box, Tabs, Tab, Paper } from '@mui/material'
import LoadFormCreationPage from './LoadFormCreationPage'
import LoadFormListPage from './LoadFormListPage'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`loadform-tabpanel-${index}`}
      aria-labelledby={`loadform-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  )
}

const LoadFormsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0)

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
  }

  return (
    <Box>
      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="load forms tabs"
          variant="fullWidth"
        >
          <Tab label="Create Load Form" />
          <Tab label="View Load Forms" />
        </Tabs>
      </Paper>

      <TabPanel value={activeTab} index={0}>
        <LoadFormCreationPage />
      </TabPanel>
      
      <TabPanel value={activeTab} index={1}>
        <LoadFormListPage />
      </TabPanel>
    </Box>
  )
}

export default LoadFormsPage
